
import Vue from 'vue'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default Vue.extend({
  props: {
    value: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data () {
    return {
      loanMask: createNumberMask({
        prefix: '',
        includeThousandsSeparator: true,
        allowNegative: false,
        thousandsSeparatorSymbol: ' '
      }),
      localValue: '0'
    }
  },

  computed: {
    sanitizedLocalValue: {
      get () {
        return this.localValue
      },
      set (value: string) {
        this.localValue = value
      }
    }
  },

  watch: {
    value (newValue) {
      this.localValue = this.splitNumber(newValue)
    }
  },

  created () {
    this.localValue = this.splitNumber(this.value)
  },

  methods: {
    splitNumber (x: number) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    },
    emitUpdate () {
      let emitValue

      const parsedLocalValue = this.localValue?.replaceAll(' ', '')

      if (!parsedLocalValue?.length) {
        emitValue = '0'
      }
      if (parsedLocalValue?.length > 9) {
        emitValue = parsedLocalValue.slice(0, 9)
      }
      if (parsedLocalValue?.startsWith('0')) {
        emitValue = parsedLocalValue.slice(1)
      }

      emitValue ??= +parsedLocalValue

      this.$emit('changed', +emitValue)
    },
    validateValues () {
      if (+this.localValue === this.value) { return }
      this.localValue = this.splitNumber(this.value)
    }
  }
})
